// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Models
import { useFormQuestionActiveValue } from '@lyon/scoped-models/form/FormQuestionActive';
import { useFormQuestionsData } from '@lyon/scoped-models/form/FormQuestionsData';
import { FormQuestionData } from '@lyon/scoped-models/form/FormQuestionData';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';
import { Scrollbar } from '@lyon/components/utils/Scrollbar';
import { LyonUpdateFormContentInitial } from './LyonUpdateFormContentInitial';
import { LyonUpdateFormContentEmpty } from './LyonUpdateFormContentEmpty';
import { LyonUpdateFormContentQuestionBody } from './LyonUpdateFormContentQuestionBody';

// ANCHOR Styles
import { BLOCK } from './styles';

export const LyonUpdateFormContent = constant(() => {
  const questions = useFormQuestionsData();
  const activeQuestionId = useFormQuestionActiveValue();

  if (typeof questions === 'undefined') {
    return <Loader />;
  }

  if (questions.length === 0) {
    return <LyonUpdateFormContentEmpty />;
  }

  if (!activeQuestionId) {
    return <LyonUpdateFormContentInitial />;
  }

  return (
    <Scrollbar>
      <Block overrides={BLOCK}>
        <FormQuestionData.Provider id={activeQuestionId}>
          <LyonUpdateFormContentQuestionBody />
        </FormQuestionData.Provider>
      </Block>
    </Scrollbar>
  );
});
